export default __webpack_public_path__ + "static/media/Info-White-Icon.91d51c49.svg";